"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFooterCtx = exports.footerCtx = exports.useFormInfo = exports.useFormVerticalGap = exports.verticalGapCtx = exports.defaultVerticalGap = exports.validateResultCtx = exports.defaultValidateStatus = exports.useFormLayout = exports.layoutCtx = exports.defaultLayout = exports.normalizeLayout = exports.useFormLabelOptions = exports.labelOptionsCtx = exports.defaultLabelGapForInline = exports.defaultLabelGapForHorizontal = exports.defaultLabelWidth = exports.defaultLabelVerticalAlign = exports.normalizeLabelColor = exports.defaultLabelColor = exports.defaultLabelAlign = exports.useFormSize = exports.sizeCtx = exports.defaultSize = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var forEach_1 = tslib_1.__importDefault(require("lodash/forEach"));
var icecream_base_1 = require("icecream-base");
exports.defaultSize = 'default';
exports.sizeCtx = react_1.createContext(exports.defaultSize);
/** 获取控件所在表单的 size 信息 */
function useFormSize(sizeFromProps) {
    var sizeFromCtx = react_1.useContext(exports.sizeCtx);
    return sizeFromProps !== null && sizeFromProps !== void 0 ? sizeFromProps : sizeFromCtx;
}
exports.useFormSize = useFormSize;
exports.defaultLabelAlign = 'left';
exports.defaultLabelColor = 'deep';
var labelColorMap = {
    light: icecream_base_1.colors.Grey.grey9,
    deep: icecream_base_1.colors.Grey.grey10
};
// LabelColor -> 色值
function normalizeLabelColor(labelColor) {
    if (labelColor === void 0) { labelColor = exports.defaultLabelColor; }
    return labelColorMap[labelColor];
}
exports.normalizeLabelColor = normalizeLabelColor;
exports.defaultLabelVerticalAlign = 'input';
exports.defaultLabelWidth = 'auto';
exports.defaultLabelGapForHorizontal = '28px';
exports.defaultLabelGapForInline = '8px';
exports.labelOptionsCtx = react_1.createContext({});
/** 获取控件所在表单的 label 相关配置 */
function useFormLabelOptions(labelOptionsFromProps) {
    var labelOptionsFromCtx = react_1.useContext(exports.labelOptionsCtx);
    var labelOptions = tslib_1.__assign({}, labelOptionsFromCtx);
    forEach_1.default(labelOptionsFromProps, function (v, k) {
        // 值为 undefined 的项应视作没传，不去覆盖 ctx 中的对应项
        if (v !== undefined)
            labelOptions[k] = v;
    });
    return labelOptions;
}
exports.useFormLabelOptions = useFormLabelOptions;
function normalizeLayout(layout) {
    return typeof layout === 'string' ? { type: layout } : layout;
}
exports.normalizeLayout = normalizeLayout;
exports.defaultLayout = { type: 'vertical' };
exports.layoutCtx = react_1.createContext(exports.defaultLayout);
// TODO 结合 ConfigProvider 里面的 size
/** 获取控件所在表单的 layout 信息 */
function useFormLayout(layoutFromProps) {
    var layoutFromCtx = react_1.useContext(exports.layoutCtx);
    return layoutFromProps != null ? normalizeLayout(layoutFromProps) : layoutFromCtx;
}
exports.useFormLayout = useFormLayout;
exports.defaultValidateStatus = 'default';
exports.validateResultCtx = react_1.createContext({
    status: exports.defaultValidateStatus,
    message: undefined
});
exports.defaultVerticalGap = '24px';
// TODO: 等 Form size 跟 ConfigProvider size 结合的事儿做完后，
// 梳理下现有的其他 Form options，可以把部分 options 合并 context
exports.verticalGapCtx = react_1.createContext(exports.defaultVerticalGap);
/** 获取所在表单的垂直间距信息 */
function useFormVerticalGap(verticalGapFromProps) {
    var verticalGapFromCtx = react_1.useContext(exports.verticalGapCtx);
    return verticalGapFromProps != null ? verticalGapFromProps : verticalGapFromCtx;
}
exports.useFormVerticalGap = useFormVerticalGap;
/** 用于输入控件获取所在表单的信息的 hook */
function useFormInfo() {
    var size = react_1.useContext(exports.sizeCtx);
    var layout = react_1.useContext(exports.layoutCtx);
    var validateResult = react_1.useContext(exports.validateResultCtx);
    return {
        size: size,
        layout: layout,
        validateStatus: validateResult.status,
        validateMessage: validateResult.message
    };
}
exports.useFormInfo = useFormInfo;
exports.footerCtx = react_1.createContext({ submitting: false });
/** 消费 footer 相关的 context 内容 */
function useFooterCtx() {
    return react_1.useContext(exports.footerCtx);
}
exports.useFooterCtx = useFooterCtx;
//# sourceMappingURL=defs.js.map